<!-- Zweck: Stellt die HTML-Struktur für dashboard widgets news entry component im Frontend bereit. -->
<div class="news-widget-entry-header">
  <table>
    <tr>
      <td rowspan="2">
        <span class="label">
          {{entry.label}}
        </span>

        @if (entry.is_new) {
          <span class="new" matTooltip="NEU">
            <svg-icon>news-neu</svg-icon>
          </span>
        }
      </td>
      <td class="time">
        <svg-icon size="12">auftragsplaner</svg-icon>
        {{entry.ts_published}}
      </td>
    </tr>
    <tr>
      <td>
        <div class="tagsbox">
          @for (tag of entry.tags; track tag) {
            <span [style.color]="tag_colors[tag.id]">{{tag.name}}</span>
          }
        </div>
      </td>
    </tr>
  </table>
</div>
<div class="content">
  <table>
    <tr>
      @if (entry.has_picture) {
        <td class="img" rowspan="2">
          <img src="{{img_base_path}}/{{entry.id}}/teaser.png" />
        </td>
      }
      <td class="text" colspan="2">
        <div [innerHTML]="entry.teaser|raw"></div>
      </td>
    </tr>
    <tr>
      <td style="vertical-align: bottom; padding-bottom: 10px" colspan="2">
        @if (entry.has_more) {
          <a routerLink="/news/{{entry.id}}" style="margin-top: 5px">
            weiterlesen
          </a>
        }
      </td>
    </tr>
    <tr>
      <td style="text-align: right; vertical-align: bottom" colspan="2">
        @if (entry.ts_seen) {
          <span>
            <small>
              gesehen: {{entry.ts_seen}}
            </small>
          </span>
        }
        <span>
          <button mat-button class="likesbutton" (click)="toggleLike()" [class.liked]="entry.ilike" matTooltip="{{entry.likes}} Likes">
            @if (entry.ilike) {
              <svg-icon>liked</svg-icon>
            }
            @if (!entry.ilike) {
              <svg-icon>like</svg-icon>
              } {{entry.likes}}
            </button>
          </span>
        </td>
      </tr>
    </table>
  </div>
